import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import * as catConsts from "./constants";

// import constants from '@/_consts';

export const state = {
  report_categories: [],
  full_cats: []
};

export const getters = {
  [catConsts.GETTERS_REPORT_CATEGORIES_LIST]: state => {
    return state.report_categories;
  },
  [catConsts.GETTERS_FULL_REPORT_CATEGORIES_LIST]: state => {
    return state.full_cats;
  }
};

export const actions = {
  [catConsts.ACTION_GET_REPORT_CATEGORIES_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().report_categories.getCategories,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(catConsts.MUTATION_SET_REPORT_CATEGORIES_LIST, response);
      }
    });
  },
  [catConsts.ACTION_GET_ALL_REPORT_CATEGORIES]: ({ commit }, employerId) => {
    employerId = employerId || 1;
    const getAllCatUrl = getEndPoints().report_categories.getAll.replace(
      ":employer_id",
      employerId
    );
    makeCall(getAllCatUrl, buildOptions("GET", {}), commit).then(
      response => {
        if (response) {
          commit(catConsts.MUTATION_SET_ALL_REPORT_CATEGORIES, response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  }
};

export const mutations = {
  [catConsts.MUTATION_SET_REPORT_CATEGORIES_LIST]: (
    state,
    reportCategories
  ) => {
    state.report_categories = reportCategories.data;
  },
  [catConsts.MUTATION_SET_ALL_REPORT_CATEGORIES]: (state, reportCategories) => {
    state.full_cats = reportCategories;
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/report_categories/index.js